<div class="main-container">
  <div class="upper-section">
    <div class="head-section">
      <div class="head-and-detail">
        <h1 class="common-head">background</h1>
        <h1 class="common-head main-heading">check</h1>
      </div>
      <div class="underline"></div>
      <p class="note">
        As part of your employment process, you'll need to complete an RCMP background check.
        You’ll receive the RCMP check link on your registered email address
        <strong *ngIf="userEmail" class="email-strong">{{ userEmail }}</strong>
        once you upload all required credentials and submit your profile for approval.
      </p>
    </div>
  </div>

  <div class="main-wrapper">
    <div class="info-wrapper">
      <ion-card class="info-card">
        <ion-card-content>
          <div class="info-row">
            <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
            <div class="info-text">
              <div class="info-title">RCMP Background Check</div>
              <div class="info-subtitle">
                No action needed here for now. Once your credentials are uploaded and your profile
                is submitted for approval, we'll email you the RCMP check to
                <strong *ngIf="userEmail" class="email-inline">{{ userEmail }}</strong>.
              </div>
            </div>
          </div>

          <div class="info-row">
            <ion-icon name="document-text-outline" aria-hidden="true"></ion-icon>
            <div class="info-text">
              <div class="info-title">Profile Submission</div>
              <div class="info-subtitle">
                You’ll only be able to submit your profile for approval after
                uploading <strong>all required documents</strong> and
                completing your <strong>identity verification</strong>.
              </div>
            </div>
          </div>

          <div *ngIf="!userEmail" class="warn">
            We couldn't determine your email from your profile. Please ensure your account email is up to date.
          </div>
        </ion-card-content>
      </ion-card>

      <div class="button-div">
        <ion-button class="register-btn" color="dark" (click)="goBack()">
          <div class="register-txt">Go back</div>
        </ion-button>
      </div>
    </div>
  </div>
</div>